import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import InvoiceItemUpdateModalUI from './InvoiceItemUpdateModalUI.js'

class InvoiceItemUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update invoice items
      submitted: false,
      // order item id
      orderItemList: [],
      orderItemIdError: null
    }
  }

  render() {
    return (
      <InvoiceItemUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        invoice={this.props.invoice}
        // update mode
        updateMode={this.props.updateMode}
        // order item id
        orderItemList={this.state.orderItemList}
        // form events
        onRowClick={this.onRowClick}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    console.log("hello1", this.props.invoice, this.props.order)
    this.getOrderItems(context)
    this.getMessages(context)
  }

  // componentDidUpdate(prevProps) {
  //   console.log("hello3", prevProps.invoice)
  //   if (this.props.invoice && (!prevProps.invoice || prevProps.invoice && this.props.invoice.customerInvoiceId !== prevProps.invoice.customerInvoiceId)) {
  //     console.log("hello2", this.props.invoice, this.props.order)
  //     this.getOrderItems(this.props.context)
  //   }
  // }

  // onOrderItemIdChange = (event) => {
  //   //let orderItem = this.state.orderItemList.find(item => item.orderItemId === event.target.value)
  //   this.setState({
  //     orderItemId: event.target.value,
  //   })

  //   console.log("hello1", event.target.value)
  // }

  onRowClick = event => {
    let itemId = event.currentTarget.getAttribute('data-row-id')
    let orderItemList = this.state.orderItemList
    orderItemList
      .filter(item => item.orderItemId === itemId)
      .forEach(item => {
        item.selected = !Boolean(item.selected)
    })

    this.setState({orderItemList : orderItemList})
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let orderItemIdList = this.state.orderItemList.filter(item => item.selected).map(item => item.orderItemId)

    RestApiUtils.put(this.props.context,
      `/api/invoices/${this.props.match.params.invoiceId}/orderItems`,
      this.onSubmitCallback, {
        orderItemIdList: orderItemIdList
    })
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'orderItemIdList':
          this.setState({ orderItemIdError: error.message })
          break;
        default:
      }
    })

    if (response.errorList.length !== 0) {
      this.setState({
        errorList: errorList,
        submitted: false
      })

      return;
    }

    let orderItemIdsInInvoice = []
    response.invoiceItemList.forEach(item => {
      orderItemIdsInInvoice.push(item.orderItemId)
    })

    let orderItemList = this.state.orderItemList
    orderItemList.forEach(item => {
      if(orderItemIdsInInvoice.find(elem => elem === item.orderItemId)) {
        item.selected = true
      } else {
        item.selected = false      
      }
    })

    this.setState({
      successMsg: response.success,
      orderItemList: orderItemList,
      submitted: false
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    this.props.onUpdateComplete(response)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      orderItemIdError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update',
      'c_update_invoice',
      'c_order_item',
      'c_cancel'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('inv_itm_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

  getOrderItems(context) {
    let cacheManager = new CacheManager({
      resource: `/api/orders/${this.props.invoice.customerOrderId}/orderItems`,
      cacheKey: CacheKeys.OrderItems(this.props.invoice.customerOrderId),
      callback: this.getOrderItemsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderItemsCallback = (response) => {
    if (response.orderItemList.length === 0) {
      // create page will not be reached without a customers
      // just redirect from here
      this.props.history.push('/settings/account/customers/create')
      return
    }

    response.orderItemList.forEach(item => {
      item.selected = item.customerInvoiceId === this.props.invoice.customerInvoiceId
    })

    this.setState({
      orderItemList: response.orderItemList
    })

    console.log("hello2", response.orderItemList)
  }
}

export default withRouter(InvoiceItemUpdateModalSF)
